import './blogPost.scss';
import * as React from 'react';
import { icons } from '../../content/icons';
import { RoutePaths } from '../../routes';
import { DateUtils } from '../../utils/date';
import { ImageUtils } from '../../utils/image';
import { Card } from '../layout/card';
import { RMButton } from '../layout/rmButton';
import { LazyCosmosImage } from '../media/cosmosImage';
import { Author } from '../people/author';
import { Tag } from '../tag';
export const BlogPostCard = ({ blogPost, latest, vertical }) => (<Card anchorClassName="blog-post-wrapper" className="blog-post" data-latest={latest} data-vertical={vertical} to={RoutePaths.blog.post(blogPost)}>
    <div className="blog-post-image">
      {blogPost.main_image && blogPost.main_image[0] && (<LazyCosmosImage ticket={blogPost.main_image[0].ticket} alt={blogPost.title} size={ImageUtils.imageSizes.medium}/>)}
    </div>

    <div className="blog-post-right">
      <h3> {blogPost.title}</h3>

      {blogPost.date && <p className="date">{DateUtils.formatDate(blogPost.date)}</p>}

      <div className="blog-post-tags">
        {blogPost.tags && blogPost.tags.map((tag) => <Tag key={tag.name} content={tag.name} to={RoutePaths.blog.postType(tag)}/>)}
      </div>

      <Author {...(blogPost?.author?.[0] || {})}/>

      {blogPost.preview && <p className="preview">{blogPost.preview}</p>}

      <RMButton variant="darken-bg" rightIcon={icons.right}>
        read more
      </RMButton>
    </div>
  </Card>);
